// Convert ISO datetime string → "YYYY-MM-DD" for <input type="date">
export const toDateInput = (val) => {
    if (!val) return "";
    return val.split("T")[0];
};

// Validate agreement date range
// Returns null if valid, error string if invalid
export const validateAgreementDates = (startDate, endDate) => {
    if (!startDate && !endDate) return null;
    if (startDate && !endDate) return null; // end date optional
    if (!startDate && endDate) return "Agreement start date is required when end date is set";
    if (new Date(endDate) < new Date(startDate)) {
        return "Agreement end date must be on or after the start date";
    }
    return null;
};

// Validate a single date field in context of the other
export const validateAgreementStartDate = (startDate, endDate) => {
    if (!startDate) return null;
    if (endDate && new Date(endDate) < new Date(startDate)) {
        return "Start date must be before end date";
    }
    return null;
};

export const validateAgreementEndDate = (endDate, startDate) => {
    if (!endDate) return null;
    if (!startDate) return "Agreement start date is required";
    if (new Date(endDate) < new Date(startDate)) {
        return "End date must be on or after start date";
    }
    return null;
};
